module.exports = __webpack_public_path__ + "img/logo.75cf51f5.png";